import {
  NavController,
  NavParams,
  App,
  ModalController,
  ViewController,
  ToastController,
} from "ionic-angular";
import { Storage } from "@ionic/storage";
import { Component, OnInit, Input } from "@angular/core";

import { AuthProvider } from "../../../../providers/auth/auth";
import { EmployeeRhProvider } from "../../../../providers/employeerh/employeerh";

@Component({
  selector: "page-rh-skillsrating",
  templateUrl: "rh-skillsrating.html",
})
export class RhSkillsRatingPage implements OnInit {
  skills: any = null;
  answers: any = {};

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public storageProvider: Storage,
    public app: App,
    public authProvider: AuthProvider,
    public employeeRhProvider: EmployeeRhProvider,
    public viewCtrl: ViewController,
    public toastCtrl: ToastController
  ) {}

  ngOnInit() {
    this.loadDatas();
  }

  loadDatas() {
    this.employeeRhProvider.getUserSkills().subscribe((res) => {
      if (res.success) {
        this.skills = res.data;
        res.data.forEach((data) => {
          this.answers[data.id] = {
            id: data.id,
            level: 0,
            motivation: 0,
          };
        });
      }
    });
  }

  logRatingChange(rating, type, skill_id) {
    if (type == "level") {
      this.answers[skill_id].level = rating;
    }

    if (type == "motivation") {
      this.answers[skill_id].motivation = rating;
    }

  }

  submitSkills(){
    let answers = this.answers;
    let hasAnsweredAll = true;
    let payload = [];
    Object.keys(answers).forEach(function (key){
        if(answers[key].level == 0 || answers[key].motivation == 0){  // Didn't answer to all question
           hasAnsweredAll = false;
        }
        payload.push(answers[key])
    })

    if(hasAnsweredAll){
        this.employeeRhProvider.setUserSkills(payload).subscribe((res) => {
            if(res.success){
                let toast = this.toastCtrl.create({ message: "Vos réponses ont été envoyées", duration: 6000, position: 'bottom'});
                toast.present();
                this.dismiss();
            }
        })
    }


  }

  // Modal ctrl
  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-skillsrating/rh-skillsrating.ts